export function getAgreementPdfUrl(relationshipId, pdfHost) {
  return "".concat(pdfHost, "/relationship-pdf/").concat(relationshipId);
}